import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'

const ImageDialog = ({ isOpen, onClose, imageUrl }) => {
    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-[20000]" onClose={onClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100"
                    leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-lg transform overflow-hidden rounded-2xl bg-white p-6 shadow-xl transition-all">
                                <Dialog.Title className="text-lg font-medium text-gray-900">
                                    Image Preview
                                </Dialog.Title>
                                <div className="mt-4">
                                    <img src={imageUrl} alt="Asset Preview" className="w-full object-contain rounded" loading="lazy" />
                                    {/* <img src={"/braceletGuidChart.png"} alt="Asset Preview" className="w-full object-contain rounded" /> */}
                                </div>
                                <div className="mt-4 text-right">
                                    <button
                                        className="inline-flex justify-center rounded-md bg-blue-500 px-4 py-2 text-white hover:bg-blue-600"
                                        onClick={onClose}
                                    >
                                        Close
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}

export default ImageDialog
